import {
  useCallback, useContext, useEffect, useRef, useState,
} from 'react';
import { AppContext } from '../../../providers/authProvider';
import api from '../../../api/req';

const SERVICE_URL = '/api/service/contractprintform/';

const usePrintContractInvoice = () => {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [mont, setMont] = useState(() => {
    const d = new Date();
    return d.getMonth();
  });
  const [year, setYear] = useState(() => {
    const d = new Date();
    return d.getFullYear();
  });

  const resultRef = useRef();

  const [result, setResult] = useState(null);

  const { currentUser, auth } = useContext(AppContext);

  const [org, setOrg] = useState(currentUser.org);
  const [contract, setContract] = useState(null);
  const [payer, setPayer] = useState(null);

  useEffect(
    () => {
      if (resultRef.current) {
        if (result) {
          resultRef.current.innerHTML = result;
        } else {
          resultRef.current.innerHTML = '';
        }
        document.getElementById('print-area').innerHTML = result;
      }
      return () => {
        document.getElementById('print-area').innerHTML = '';
      };
    },
    [result],
  );

  const onGenerateForm = useCallback(
    () => {
      const req = async () => {
        const d = new Date(year, mont, 1);
        d.setMinutes(-d.getTimezoneOffset());
        const payload = {
          org,
          date: d.toJSON().substring(0, 10),
          ...(payer ? { payer } : {}),
          ...(contract ? { contract } : {}),
        };
        const r = await api.post(SERVICE_URL, auth, payload);
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return r.json();
      };
      setLoading(true);
      setErr(null);
      req()
        .then((d) => {
          const dd = /^data:text\/html;base64,(.*)$/gm.exec(d.file);
          setResult(decodeURIComponent(escape(atob(dd[1]))));
        })
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    },
    [auth, contract, mont, org, payer, year],
  );

  const onSetOrg = useCallback(
    (v) => {
      if (currentUser.is_superuser) setOrg(v);
    },
    [currentUser.is_superuser],
  );

  const printAllowed = !!result;

  return ({
    loading,
    err,
    org,
    onSetOrg,
    currentUser,
    mont,
    setMont,
    year,
    setYear,
    contract,
    setContract,
    payer,
    setPayer,
    onGenerateForm,
    resultRef,
    printAllowed,
  });
};

export default usePrintContractInvoice;
